// extracted by mini-css-extract-plugin
module.exports = {"suffix":"FOulT","prefix":"_3fKeB"};